import React from "react";
import CustomSpin from "../Spins/CustomSpin";

const SectionLoader = ({ className }) => {
  return (
    <div
      className={`flex flex-row justify-center items-center w-full h-full bg-white/80 absolute top-0 left-0 right-0 bottom-0 z-50 ${
        className ? className : ""
      }`}
    >
      <CustomSpin />
    </div>
  );
};

export default SectionLoader;
